import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import BossManagementPage from './pages/BossManagementPage';
import EnvironmentError from './components/common/EnvironmentError';
import { AuthGuard } from './components/AuthGuard';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();

  // 환경 변수 체크
  const hasSupabaseConfig = 
    process.env.REACT_APP_SUPABASE_URL && 
    process.env.REACT_APP_SUPABASE_ANON_KEY;

  if (!hasSupabaseConfig) {
    return <EnvironmentError />;
  }

  return (
    <AuthGuard>
      <BossManagementPage />
    </AuthGuard>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
